import PropTypes from "prop-types";
import { useEffect } from "react";
// @mui
import List from "@mui/material/List";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
// hooks
import { useBoolean } from "src/hooks/use-boolean";
// routes
import { usePathname } from "src/routes/hooks";
// components
import Logo from "src/components/logo";
import SvgColor from "src/components/svg-color";
import Scrollbar from "src/components/scrollbar";
//
import NavList from "./nav-list";
import DownloadButtons from "src/sections/home/components/download_Buttons";
import { Stack } from "@mui/system";

// ----------------------------------------------------------------------

export default function NavMobile({ offsetTop, data }) {
  const pathname = usePathname();

  const nav = useBoolean();

  useEffect(() => {
    if (nav.value) {
      nav.onFalse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <>
      <IconButton
        onClick={nav.onTrue}
        sx={{
          ml: 0,
          ...(offsetTop && {
            color: "text.primary",
          }),
        }}
      >
        <SvgColor src="/assets/icons/navbar/ic_menu_item.svg" />
      </IconButton>

      <Drawer
        open={nav.value}
        onClose={nav.onFalse}
        PaperProps={{
          sx: {
            pb: 5,
            width: 260,
          },
        }}
      >
        <Scrollbar>
          <Logo sx={{ mx: 2.5, my: 3 }} />

          <List component="nav" disablePadding>
            {data.map((link) => (
              <NavList key={link.title} item={link} nav={nav} />
            ))}
          </List>
          <Stack
            alignItems="start"
            spacing={1.5}
            sx={{ marginLeft: ".5rem", marginTop: ".5rem" }}
          >
            <DownloadButtons
              image={"/assets/icons/app/apple.svg"}
              // title="App Store"
              description="Download App"
              backgrounColor="transparent"
              color="#212B36"
            />
            <DownloadButtons
              image={"/assets/icons/app/playstore.svg"}
              // title="App Store"
              description="Download App"
              backgrounColor="#13ac96"
              color="#FFFFFF"
            />
          </Stack>
        </Scrollbar>
      </Drawer>
    </>
  );
}

NavMobile.propTypes = {
  data: PropTypes.array,
  offsetTop: PropTypes.bool,
};
